import Vue from 'vue'

const $const = {
    AUTHENTICATE_STATUS: {
        AUTHENTICATED: 'authenticated',
        UNAUTHENTICATED: 'unauthenticated'
    },
    NOTIFICATION_TYPE: {
        USER_MSG: 'message_of_customer',
        ADMIN_MSG: 'message_of_supporter',
        BOT_STATUS: 'status_of_bot',
        CUSTOMER_STATUS: 'customer_status',
        CUSTOMER_REQUEST_SUPPORT: 'customer_request_support',
        LEADER_ASSIGNMENT: 'leader_assignment'
    },
    SOCKETCLUSTER_NOTI_CHANNEL: {
        APP: 'system_bot_notification@', // + bot_code
        USER: 'system_sp_notification@' // + user_id
    },
    SOCKETCLUSTER_NOTI_DATA_TYPE: {
        DEACTIVATE_BOT: "deactivate_bot",
        USER_REQUEST_SUPPORT: "user_request_support",
        USER_NEED_SUPPORT_SEND_MSG: "user_need_sp_send_msg",
        ADMIN_SEND_MSG: "admin_send_msg",
        USER_SEND_MSG: "user_send_msg",
        USER_REACTED_MESSAGE: 'user_reacted_message',
        BOT_SEND_MSG: "bot_send_msg",
        ADMIN_ASSIGN_SUPPORT: "admin_assign_support",
        MARK_AS_DONE: "mark_as_done",
        MESSAGE_SEEN: "message_seen",
        LONG_WAIT: "long_wait_status",
        UPDATE_AUTO_ASSIGN_CONFIG: "update_auto_assign_config",
        COUNT_REQUEST_SUPPORT_CHANGED: "count_request_support_changed",
        SESSION_REPORT_STATUS: "session_report_status",
        TICKET_REPORT_STATUS: "ticket_report_status",
        TICKET_EVENT: "ticket_event",
        BLOCK_CUSTOMER_EVENT: "block_customer_event",
        SESSION_EVENT: "session_event",
        USER_DELETED_MESSAGE: "user_deleted_message",
        AGENT_SLA_OVERDUE: 'agent_sla_overdue',
        WARNING: 'warning',
    },
    TICKET_EVENT: {
        NEW_TICKET: "new_ticket",
        CLOSE_TICKET: "close_ticket"
    },
    SESSION_EVENT: {
      NEW_SESSION: "new_session",
      END_SESSION: "end_session"
    },
    STAFF_CHANNEL: 'private',
    BOT_ROLE: {
        OWNER: 'bot_owner',
        ADMIN: 'bot_admin',
        LEADER: 'bot_customer_support_lead',
        SUPPORTER: 'bot_supporter'
    },
    ROLE_FEATURES: {
        ACCESS_LIVE_SUPPORT_PAGE: 'access_live_support_page',
        ACCESS_LIVE_SUPPORT_PAGE_AS_LEADER: 'access_live_support_page_as_leader',
        ACCESS_LIVE_SUPPORT_AS_OUTSOURCE_SUPPORTER: 'access_live_support_as_outsource_supporter',
    },
    BOT_SUPPORTER: {
        name: 'BOT',
        email: ''
    },
    DATE_FORMAT: 'YYYY-MM-DD',
    ENV: {
        VUE_APP_HOST: process.env.VUE_APP_HOST,
        VUE_APP_SOCKETCLUSTER_HOST: process.env.VUE_APP_SOCKETCLUSTER_HOST,
        VUE_APP_FPTAI_MESSENGER_BACKEND_HOST: process.env.VUE_APP_FPTAI_MESSENGER_BACKEND_HOST,
        VUE_APP_MESSENGER_HOST: process.env.VUE_APP_MESSENGER_HOST,
        VUE_APP_BASE_API_MESSENGER: process.env.VUE_APP_BASE_API_MESSENGER,
        VUE_APP_FPTAI_BOT_HOST: process.env.VUE_APP_FPTAI_BOT_HOST
    },
    MSG_TYPE: {
        TEXT: 'text',
        IMAGE: 'image',
        CAROUSEL: 'carousel',
        QUICK_REPLY: 'quick_reply',
        PAYLOAD: 'payload',
        REQUEST_HUMAN_SUPPORT: 'request_human_support',
        TYPING: 'typing',
        FILE: 'file',
        ZALO_LIST_TEMPLATE: 'zalo_list_template',
        STICKER: 'sticker',
    },
    INTEGRATION_CHANNEL: {
        ALL: 'all',
        LIVE_CHAT: 'livechat',
        FACEBOOK: 'facebook',
        INSTAGRAM: 'instagram',
        ZALO: 'zalo',
        VIBER: 'viber',
        WORKPLACE: 'fbatwork',
        API: 'api',
        HI_FPT: 'hifpt',
        LINE: 'line',
        GOOGLE_BUSINESS_MESSAGE: 'google_biz_msg',
        WHATSAPP: 'whatsapp',
        TEAMS: 'teams',
        TIKTOK: "tiktok"
    },
    ALL_CHAT_CHANNELS: [
        'all',
        'livechat',
        'facebook',
        'instagram',
        'fbatwork',
        'zalo',
        'viber',
        'google_biz_msg',
        'hifpt',
        'line',
        'api',
        'teams',
        'tiktok',
    ],
    LOCAL_STORAGE_KEY: {
        FPTAI_MESSENGER_USER_JWT: 'fptai_messenger_user_jwt',
        PATH_CACHE: 'path_cache',
        PROVIDER: 'provider'
    },
    SOCKET_API_METHODS: {
        ADMIN_SEND_MESSAGE: 'admin_send_message',
        ADMIN_REQUEST_AUTHENTICATE: 'admin_request_authenticate',

    },
    CHATLOG_SOURCE: {
        RECEIVE: 1,  // tin nhắn nhận từ người dùng
        SEND: 2,  // tin nhắn từ hệ thống gửi cho người dùng
    },
    CHATLOG_TYPE: {
        NORMAL: 1,  // Tin nhắn bình thường ngời dùng vs bot, bot vs ng
        SYSTEM: 2,  // Tin nhắn từ hệ thống tới người dùng (broadcast) -> Deprecated
        ADMIN: 3,  // Admin gửi tin nhắn đến người dùng, người dùng chat với admin
        SEND_BROADCAST: 4,  // Send broadcast
        SEND_REMINDER: 5,  // Send reminder
        CALL_SEND_MESSAGE_API: 6,  // Send message controllers
    },
    ALLOW_ATTACHMENT_EXTENSION: ['tif', 'png', 'gif', 'ico', 'jpg', 'docx', 'doc', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'jpeg'],
};

Vue.prototype.$const = $const;

export default $const;
